import { Title, Texts, Media, Button } from "../Object";
import { Space } from "../Layout";
import { Scroll } from "../Animation";

const About = (props) => {
  return (
    <>
      <div className="p-box__wrap--left-dec">
        <div className="l-row" data-state="right">
          <div className="p-box__wrap--gray">
            <Space size={["100px", "72px"]} />
            <div className="l-row l-row--normal">
              <Texts slug="about/title" class="c-text--bold" />
              <Space size={["40px 0 64px", "32px 0 48px"]}>
                <Texts slug="about/body" class="c-text--med" />
              </Space>
              <Scroll>
                <Media
                  sp="sp"
                  src="about/about-main"
                  class="p-img__about"
                  alt="非熟練者未経験者技術を習得 -> 技術・技能ノウハウを得て母国に貢献"
                />
              </Scroll>
              <Space size={["64px 0 0", "48px 0 0"]}>
                <Button type="center" link="/point/" slug="point"></Button>
              </Space>
            </div>
            <Space size={["100px", "72px"]} />
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
